export default {"src":"/_next/static/media/ziraat.92a1ec50.svg","height":19,"width":66};